import {
  getAll,
  getPage,
  getSignLessThanTen,
  getGPSLessThanTen,
} from '@/api/wirelessdataserv'

export default {
  state: {
    state_WirelessData_GetAllResult: null,
    state_WirelessData_GetPageResult: null,
    state_WirelessData_GetSignLessThanTenResult: null,
    state_WirelessData_GetGPSLessThanTenResult: null,
  },
  mutations: {
    SET_WIRELESSDATA_GETALL_RESULT: (state, rst) => {
      state.state_WirelessData_GetAllResult = rst;
    },
    SET_WIRELESSDATA_GETPAGE_RESULT: (state, rst) => {
      state.state_WirelessData_GetPageResult = rst;
    },
    SET_WIRELESSDATA_GETSIGNLESSTHANTEN_RESULT: (state, rst) => {
      state.state_WirelessData_GetSignLessThanTenResult = rst;
    },
    SET_WIRELESSDATA_GETGPSLESSTHANTEN_RESULT: (state, rst) => {
      state.state_WirelessData_GetGPSLessThanTenResult = rst;
    },
  },
  actions: {
    WirelessDataServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WIRELESSDATA_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WIRELESSDATA_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WirelessDataServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WIRELESSDATA_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WIRELESSDATA_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WirelessDataServ_GetSignLessThanTen({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getSignLessThanTen(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WIRELESSDATA_GETSIGNLESSTHANTEN_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WIRELESSDATA_GETSIGNLESSTHANTEN_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WirelessDataServ_GetGPSLessThanTen({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getGPSLessThanTen(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WIRELESSDATA_GETGPSLESSTHANTEN_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WIRELESSDATA_GETGPSLESSTHANTEN_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_WirelessData_GetAllResult: state => {
      return state.state_WirelessData_GetAllResult;
    },
    get_WirelessData_GetPageResult: state => {
      return state.state_WirelessData_GetPageResult;
    },
    get_WirelessData_GetSignLessThanTenResult: state => {
      return state.state_WirelessData_GetSignLessThanTenResult;
    },
    get_WirelessData_GetGPSLessThanTenResult: state => {
      return state.state_WirelessData_GetGPSLessThanTenResult;
    },
  }
}